// Tile download, shared by the collection grids and the fullscreen preview.

/** `<slug>-<seed>.<ext>`, matching the server's suggestedFileName. */
export function tileFileName(name, seed, ext = 'png') {
  const slug =
    String(name || 'sogni-tile')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'sogni-tile';
  // Number(null)/Number('') are 0, so guard explicitly: a missing seed adds no
  // suffix (matching the server's suggestedFileName), never a bogus `-0`.
  const num = seed == null || seed === '' ? NaN : Number(seed);
  const tag = Number.isFinite(num) ? `-${num}` : '';
  return `${slug}${tag}.${ext}`;
}

/** Save a tile. Fetched as a blob because a cross-origin <a download> is
 *  ignored by browsers and would navigate instead of saving. */
export async function downloadTile(src, name = 'sogni-tile', seed) {
  try {
    const blob = await fetch(src).then((r) => r.blob());
    // The extension follows the blob's real type, so a JPG tile saves as .jpg,
    // an older PNG favourite still saves as .png, and an animated loop saves
    // as .mp4 — independent of whatever format the current roll is set to.
    const ext = blob.type === 'image/jpeg' ? 'jpg' : blob.type === 'video/mp4' ? 'mp4' : 'png';
    const href = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = href;
    a.download = tileFileName(name, seed, ext);
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 10_000);
  } catch (err) {
    console.warn('download failed:', err.message);
  }
}
